// import { useEffect } from "react";
import DatePicker from '../../../General/DatePicker';
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import ValidationText from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/Items/ValidationText';

const Date = ({ item, setItem, activeAccordion, validations }) => {
  const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);

  const handleSetDate = (date) => {
    handleSetAnswer({ target: { value: date } }, item);
  }
  return (
    <div className='content-box d-flex gap-10 align-items-center'>
      <p className={`text text-black w-231px flex-shrink-0 d-flex  justify-content-end gap-01 text-end  ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
        {item.content || '[Enter prompt or question]'}
        {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>}
      </p>
      <div className={`input mb-0 w-100 ${validations.isInvalid ? 'error' : ''}`}>
        <DatePicker
          id="dateInput"
          value={item.answer}
          handleCalendarChangefunc={date => handleSetDate(date)}
          showLabel={false}
        />
        {validations?.isInvalid ?
          <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
            <i className="bi bi-info-circle-fill fs-10"></i>
            <p className="fs-9 text-white text">Date is Required!</p>
          </div> : ''}
      </div>
    </div>
  );
};

export default Date